import dynamic from 'next/dynamic';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Skeleton from 'react-loading-skeleton';
import cx from 'classnames';

import useWindowSize from '#app/hooks/useWindowSize';

import styles from './index.module.scss';
import { typo_56, typo_24 } from '../../atoms/typography/typography.module.scss';

const Typography = dynamic(() => import('../../atoms/typography/typography'));
const Button = dynamic(() => import('../../molecules/button/button'));

const Hero = ({
  title,
  type, // first_course | no_accesible_course | individual_course
  pathData,
  description,
  button,
  image,
  paddingTop,
  paddingBottom,
  titleColor,
  descriptionColor,
  backgroundColor,
  breadcrumbs,
  footer,
  bottomPX = [0, 0],
  rightPX = [0, 0],
  isPaddingImage
}) => {
  const { isMobile, isDesktop } = useWindowSize();

  return (
    <section className={styles.wrapper} style={{ backgroundColor: backgroundColor }}>
      <div
        className={styles.container}
        style={{
          paddingTop: isDesktop ? `${paddingTop[0]}px` : `${paddingTop[1]}px`,
          paddingBottom: isDesktop ? `${paddingBottom[0]}px` : `${paddingBottom[1]}px`
        }}
      >
        {/* Text */}
        <div className={styles.text}>
          {isDesktop && breadcrumbs}

          <div
            className={cx(styles.information, {[styles.information__background]: !(type === 'individual_course')})}
          >
            <div>
              {type === 'individual_course' ? (
                <Typography variant={typo_24} fontWeight={700} center={isMobile} tag="p">
                  Curso:
                </Typography>
              ) : (
                <div className={styles.information__background_info}>
                  <div className={styles.information__background_info_text}>
                    <Typography
                      fontSize={[16, 14]}
                      lineHeight={[24, 20]}
                      margin={{ right: [2, 2] }}
                      tag="p"
                    >
                      Curso
                    </Typography>

                    <div className={styles.information__background_info_text_number}>
                      <Typography
                        fontSize={[16, 14]}
                        fontWeight={700}
                        lineHeight={[24, 20]}
                        color="white"
                        tag="p"
                      >
                        {pathData && pathData.order}
                      </Typography>
                    </div>

                    <Typography
                      fontSize={[16, 14]}
                      lineHeight={[24, 20]}
                      margin={{ left: [6, 6] }}
                      tag="span"
                    >
                      de la ruta:
                    </Typography>
                  </div>

                  <div className={styles.information__background_info_path}>
                    <Typography
                      fontSize={[16, 14]}
                      lineHeight={[24, 20]}
                      margin={{ left: [6, 6] }}
                      tag="span"
                    >
                      {pathData && pathData.name}
                    </Typography>
                  </div>
                </div>
              )}

              <Typography
                variant={typo_56}
                fontWeight={700}
                color={titleColor}
                center={isMobile}
                tag="h1"
              >
                {title && title.replace(/Paquete: |Paquete 1: |Paquete 2: /, '')}
              </Typography>
            </div>

            {description && (
              <Typography
                fontSize={type === 'individual_course' ? [24, 14] : [16, 14]}
                lineHeight={type === 'individual_course' ? [32, 24] : [24, 20]}
                fontWeight={400}
                color={descriptionColor}
                center={isMobile}
                margin={{ bottom: [0, 20] }}
                tag="p"
              >
                {description}
              </Typography>
            )}

            {!(type === 'no_accesible_course') && (
              <Button
                type={button.type}
                href={button.href}
                target={button.target}
                iconRight={button.iconRight}
                scrollOptions={button.scrollOptions}
                variant={button.variant}
                width={isMobile ? '100%' : '308px'}
                height={button.height}
                textOptions={{
                  fontSize: [button.fontSize[0], button.fontSize[1]],
                  lineHeight: [button.lineHeight[0], button.lineHeight[1]],
                  fontWeight: button.fontWeight
                }}
              >
                {button.name}
              </Button>
            )}
          </div>
        </div>

        {/* Image */}
        <div
          className={styles.image}
          style={{
            bottom: isDesktop ? `${bottomPX[0]}px` : `${bottomPX[1]}px`,
            right: isDesktop ? `${rightPX[0]}px` : `${rightPX[1]}px`,
            padding: isPaddingImage && isMobile ? `0 30px` : `0px 0px`
          }}
        >
          <LazyLoadImage
            effect="blur"
            width="100%"
            height={isDesktop ? '390px' : '290px'}
            alt={title}
            src={isDesktop ? image[0] : image[1]}
            threshold={-100}
            placeholder={<Skeleton width="100%" height="100%" />}
          />
        </div>
      </div>

      {/* Footer */}
      {footer}
    </section>
  );
};

export default Hero;
